import { combineReducers } from "redux";
import { UserReducer } from "./me";
import { NotificationReducer } from "./notification";
import { AuthReducer } from "./auth";
import { AllLanguageListReducer } from "./language";
import { AllLabelsReducer } from "./label";

export const RootReducer = combineReducers({
  notifications: NotificationReducer,
  me: UserReducer,
  auth: AuthReducer,
  all_language_list: AllLanguageListReducer,
  all_labels: AllLabelsReducer
});
